import { Divider } from 'antd';
import styled from 'styled-components';

export const Header = styled.header<{ $isDesktop: boolean }>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${({ $isDesktop }) => ($isDesktop ? '36px 24px 0' : '4px 20px 0')};
  .ant-typography {
    margin: 0;
  }
`;

interface HeaderDividerProps {
  $margin?: string;
}

export const HeaderDivider = styled(Divider)<HeaderDividerProps>`
  margin: ${({ $margin }) => ($margin ? $margin : '12px 0 0 0')};
`;
